// extracted by mini-css-extract-plugin
export default {"status_icon":"RequestStatus_status_icon__dV2Nf","green_color":"RequestStatus_green_color__Ymy-d","red_color":"RequestStatus_red_color__N11E4"};